import React, { useContext, useRef, useState } from "react";
import Reveal from "react-reveal/Reveal/";
import { LocationContext } from "../../store/LocationContext";
import emailjs from "@emailjs/browser";
import bannerVideo from "../../video/hero-video.mp4";

// Configuration map for location-specific icons/folders
const locationConfig = {
    "": { iconFolder: "home", iconName: "home" },
    "Acacia Ridge": { iconFolder: "acacia", iconName: "acacia" },
    "Brisbane": { iconFolder: "brisbane", iconName: "brisbane" },
    "Beenleigh": { iconFolder: "beenleigh", iconName: "beenleigh" },
    "Coopers Plains": { iconFolder: "coopers", iconName: "coopers" },
    "Gold Coast": { iconFolder: "gold-coast", iconName: "goldcoast" },
    "Ipswich": { iconFolder: "ipswich", iconName: "ipswich" },
    "Rocklea": { iconFolder: "rocklea", iconName: "rocklea" },
    "Sunnybank": { iconFolder: "sunnybank", iconName: "sunnybank" },
    "Toowoomba": { iconFolder: "toowoomba", iconName: "toowoomba" },
    "Underwood": { iconFolder: "underwood", iconName: "underwood" },
    "Woodridge": { iconFolder: "woodridge", iconName: "woodridge" },
};

const DesignBanner = () => {
    const { location } = useContext(LocationContext);
    const [status, setStatus] = useState(undefined);
    const form = useRef();

    // Get configuration based on current location context, fallback to home defaults
    const currentConfig = locationConfig[location] || locationConfig[""];
    const { iconFolder, iconName } = currentConfig;

    function sendEmail(e) {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_p9df8cl",
                "template_br93me6",
                form.current,
                "kPAKgVXXjmnGEzJGp"
            )
            .then(
                (result) => {
                    setStatus({ type: "success" });
                    form.current.reset(); // Native form reset handles all fields automatically!
                },
                (error) => {
                    setStatus({ type: "error" });
                }
            );
    }

    return (
        <section className="seo_home_area">
            <div className="home_bubble">
                <img
                    className="bubble b_one"
                    src={require(`../../img/seo/${iconFolder}/car-1-${iconName}.png`)}
                    alt="truck-icon"
                />
                <img
                    className="bubble b_two"
                    src={require(`../../img/seo/${iconFolder}/dollar-2-${iconName}.png`)}
                    alt="cash-icon"
                />
                <img
                    className="bubble b_three"
                    src={require(`../../img/seo/${iconFolder}/dollar-1-${iconName}.png`)}
                    alt="dollar-icon"
                />
                <img
                    className="bubble b_four"
                    src={require(`../../img/seo/${iconFolder}/car-2-${iconName}.png`)}
                    alt="car-icon"
                />
                <img
                    className="bubble b_five"
                    src={require(`../../img/seo/${iconFolder}/dollar-1-${iconName}.png`)}
                    alt="dollar-icon"
                />
                <img
                    className="bubble b_six"
                    src={require(`../../img/seo/${iconFolder}/dollar-2-${iconName}.png`)}
                    alt="cash-icon"
                />
            </div>
            <div className="banner_top">
                <div className="container custom_container">
                    <div className="row">
                        <div className="col-md-12 col-lg-8 seo_banner_content mb-5">
                            <h3 className="text-center">
                                Get instant cash for your used/scrap car
                            </h3>
                            <div className="saas_home_img">
                                <Reveal effect="fadeInUp" duration={1400}>
                                    <div className="embed-responsive embed-responsive-4by3">
                                        <video
                                            src={bannerVideo}
                                            autoPlay
                                            loop
                                            muted
                                            defaultMuted
                                            playsInline
                                            className="embed-responsive-item"
                                            style={{
                                                filter: "brightness(100%)",
                                            }}
                                        ></video>
                                    </div>
                                </Reveal>
                            </div>
                        </div>
                        <Reveal effect="fadeInUp" duration={1400}>
                            <div className="contact_form col-md-12 col-lg-4">
                                <form
                                    ref={form}
                                    className="quote_form"
                                    onSubmit={sendEmail}
                                >
                                    <h4 className="text-center pb-3">
                                        Get free quotation now!
                                    </h4>
                                    {status?.type === "success" && (
                                        <p className="alert alert-success">
                                            Message Sent Successfully
                                        </p>
                                    )}
                                    {status?.type === "error" && (
                                        <p className="alert alert-danger">
                                            Message Not Sent
                                        </p>
                                    )}
                                    <div className="row">
                                        <div className="form-group col-12 text_box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                placeholder="Your Name"
                                                required
                                            />
                                        </div>
                                        <div className="col-12 text_box">
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                placeholder="Your Email"
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-6 text_box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="phone-number"
                                                name="phone_number"
                                                placeholder="Your Phone Number"
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-6 text_box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="sub-urb"
                                                name="sub_urb"
                                                placeholder="Your Suburb"
                                                required
                                            />
                                        </div>
                                        <div className="col-12 text_box">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="make-model"
                                                name="make"
                                                placeholder="Year Make Model"
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-md-12 text_box">
                                            <textarea
                                                className="form-control message"
                                                id="message"
                                                name="message"
                                                placeholder="Your Message"
                                                required
                                                rows="1"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button
                                            className="btn_three"
                                            type="submit"
                                        >
                                            Get Quote Now
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default DesignBanner;